import React from 'react';
import styled from 'styled-components';
import { colors } from '../../const/Styles';

const Container = styled.div`
    display: flex;
    flex-direction: row;
    padding: 12px 0px;
    justify-content: center;
    box-sizing: border-box;
    border-top: 2px solid ${colors.lighterGray};
    width: 100%;
    gap: 32px;
`;

const ActionButton = styled.button<{ hasMultipleButtons?: boolean }>`
    display: flex;
    flex-direction: row;
    padding: 3px;
    outline: none;
    border: none;
    border-radius: 4px;
    color: ${colors.black};
    background-color: ${colors.footerIconSelected};
    font-size: 18px;
    font-weight: bold;
    justify-content: center;
    width: 100%;
    max-width: ${({ hasMultipleButtons }) =>
        hasMultipleButtons ? '244px' : '550px'};
`;

export type FooterButton = {
    label: string;
    onClick: () => void;
};

type Props = {
    onClickSave: () => void;
    extraButtons?: FooterButton[];
};

const Footer: React.FC<Props> = ({ onClickSave, extraButtons }) => {
    const hasMultipleButtons = extraButtons && extraButtons.length >= 1;
    return (
        <Container>
            <ActionButton
                type='button'
                onClick={onClickSave}
                hasMultipleButtons={hasMultipleButtons}
            >
                保存
            </ActionButton>
            {extraButtons &&
                extraButtons.map((btn) => (
                    <ActionButton
                        key={btn.label}
                        type='button'
                        onClick={btn.onClick}
                        hasMultipleButtons={hasMultipleButtons}
                    >
                        {btn.label}
                    </ActionButton>
                ))}
        </Container>
    );
};

export default Footer;
